import { useEffect, useState } from "react";
import { t } from "@/i18n-js/instance";
import type { MobileHomeSegment } from "@/react/types/MobileHomeSegment";
import { MobileSettingsBanner } from "@circle-react-shared/PlusUpgradeBanners/MobileSettingsBanner";
import { Button } from "@circle-react-uikit/Button";
import { Form } from "@circle-react-uikit/Form";
import { Loader } from "@circle-react-uikit/Loader";
import { FormContent } from "../Layout/FormContent";
import { FormWrapper } from "../Layout/FormWrapper";
import { SettingsContainer } from "../SettingsContainer";
import { SettingsHeader } from "../SettingsHeader";
import { MobileAppFormFields } from "./MobileAppFormFields";
import { MobileHomeSegmentsProvider } from "./MobileHomeSegmentsContext";
import { useMobileAppSettings } from "./hooks/useMobileAppSettings";

export const I18N_ROOT = "settings.mobile_app";

export const MobileApp = () => {
  const { defaultValues, mobileHomeSegments, isLoading, mutate, isSaving } =
    useMobileAppSettings();

  const [orderedMobileHomeSegments, setOrderedMobileHomeSegments] = useState<
    MobileHomeSegment[]
  >([]);

  useEffect(() => {
    setOrderedMobileHomeSegments(mobileHomeSegments);
  }, [mobileHomeSegments]);

  const handleSubmit = (payload: any) => {
    payload.community_setting.mobile_home_segments_order =
      orderedMobileHomeSegments.map(
        (segment: MobileHomeSegment) => segment.kind,
      );
    mutate(payload);
  };

  if (isLoading) {
    return <Loader center />;
  }

  return (
    <MobileHomeSegmentsProvider
      orderedMobileHomeSegments={orderedMobileHomeSegments}
      setOrderedMobileHomeSegments={setOrderedMobileHomeSegments}
    >
      <SettingsHeader pageTitle={t([I18N_ROOT, "title"])} />
      <SettingsContainer>
        <MobileSettingsBanner />
        <FormWrapper>
          <FormContent subtitle={t([I18N_ROOT, "subtitle"])}>
            <Form defaultValues={defaultValues} onSubmit={handleSubmit}>
              <MobileAppFormFields />
              <div className="flex justify-end">
                <Button
                  type="submit"
                  variant="circle"
                  disabled={isSaving}
                  large
                >
                  {isSaving ? t("saving") : t("save_changes")}
                </Button>
              </div>
            </Form>
          </FormContent>
        </FormWrapper>
      </SettingsContainer>
    </MobileHomeSegmentsProvider>
  );
};

export default MobileApp;
